const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL = process.env.NODE_ENV === "production" ? "" : CONFIGURED_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const readJson = async (response) => response.json().catch(() => ({}));

const actionErrorMessage = (payload, fallback) => {
  const detail = payload?.detail;
  if (typeof detail === "string") return detail;
  return detail?.message
    || payload?.message
    || payload?.record?.execution_result?.message
    || fallback;
};

const resultDevice = (payload) => payload?.affected_devices?.[0] || null;

const throwActionResult = (payload, fallback) => {
  if (payload?.record?.status === "AWAITING_CONFIRMATION") {
    const error = new Error(payload?.message || "Diese Geräteaktion benötigt deine Bestätigung.");
    error.code = "ACTION_CONFIRMATION_REQUIRED";
    error.actionId = payload?.record?.action_id;
    error.actionRecord = payload?.record;
    throw error;
  }

  if (!payload?.success) {
    const error = new Error(actionErrorMessage(payload, fallback));
    error.code = payload?.error_class || payload?.record?.execution_result?.code || "DEVICE_ACTION_FAILED";
    throw error;
  }

  const updated = resultDevice(payload);
  if (!updated) {
    const error = new Error("Geräteaktion wurde verarbeitet, aber kein verifizierter Gerätezustand zurückgegeben.");
    error.code = "DEVICE_ACTION_RESULT_MISSING";
    throw error;
  }
  return updated;
};

export const getDevices = async (token) => {
  const res = await fetch(`${API}/devices`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: "include",
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch devices: ${res.status}`);
  }

  return await res.json();
};

export const executeDeviceAction = async (deviceId, action, token) => {
  const res = await fetch(`${API}/devices/${encodeURIComponent(deviceId)}/action`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: "include",
    body: JSON.stringify(action),
  });

  const payload = await readJson(res);
  if (!res.ok) {
    if (payload?.detail?.code === "ACTION_CONFIRMATION_REQUIRED" && payload?.detail?.action_id) {
      const error = new Error(payload.detail.message || "Diese Geräteaktion benötigt deine Bestätigung.");
      error.code = "ACTION_CONFIRMATION_REQUIRED";
      error.actionId = payload.detail.action_id;
      throw error;
    }
    const error = new Error(actionErrorMessage(payload, "Device action failed"));
    error.code = payload?.detail?.code || "DEVICE_ACTION_FAILED";
    throw error;
  }

  return payload;
};

export const confirmDeviceAction = async (actionId, token) => {
  const res = await fetch(`${API}/intelligence/actions/${encodeURIComponent(actionId)}/confirm`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: "include",
    body: JSON.stringify({ session_id: null }),
  });

  const payload = await readJson(res);
  if (!res.ok) {
    throw new Error(actionErrorMessage(payload, "Bestätigung der Geräteaktion fehlgeschlagen"));
  }

  return throwActionResult(payload, "Bestätigung der Geräteaktion fehlgeschlagen");
};
